import React, { Suspense, lazy, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useCoachFastBookStudentEnabled } from 'lib/pga-coach/use-coach-fast-book-student'
import { isCoachFastBookOverlayOpen } from 'lib/pga-coach/coach-book-student'

let stepControllerChunk
const loadStepController = () => {
  stepControllerChunk =
    stepControllerChunk || import('./coach-book-student-step-controller')
  return stepControllerChunk
}

const CoachBookStudentStepController = lazy(loadStepController)

const preloadFastBookChunks = () => {
  loadStepController()
  import('./coach-book-student-compose')
}

const CoachFastBookStudentOverlay = () => {
  const location = useLocation()
  const isFastBookEnabled = useCoachFastBookStudentEnabled()
  const isOpen = isCoachFastBookOverlayOpen(location.search)

  useEffect(() => {
    if (!isFastBookEnabled || isOpen) return undefined
    const schedule = window.requestIdleCallback || (cb => setTimeout(cb, 1))
    const cancel = window.cancelIdleCallback || clearTimeout
    const handle = schedule(preloadFastBookChunks)
    return () => cancel(handle)
  }, [isFastBookEnabled, isOpen])

  if (!isFastBookEnabled || !isOpen) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <CoachBookStudentStepController />
    </Suspense>
  )
}

export default CoachFastBookStudentOverlay
